import { useParams } from 'react-router-dom';
import { LogoMarque } from '../marque/LogoMarque';
import { ErreurApi } from '../lib/api';
import { useQuestionnaireParLien, useRepondreParLien } from '../lib/useQuestionnaires';
import { FormulaireQuestionnaire } from '../components/questionnaires/FormulaireQuestionnaire';
import { useTitrePage } from '../lib/useTitrePage';

/**
 * Questionnaire ouvert par le lien personnel du mail (CDC §8.2), sans session :
 * après l'examen, beaucoup d'apprenants ne se reconnectent plus à leur espace.
 * Le lien ne donne accès qu'à ce questionnaire, et il ne se remplit qu'une fois.
 */
export function QuestionnairePublicPage(): JSX.Element {
  useTitrePage('Questionnaire');
  const { jeton = '' } = useParams();
  const { data, isLoading, error } = useQuestionnaireParLien(jeton);
  const repondre = useRepondreParLien(jeton);

  return (
    <div className="login-bg flex min-h-screen items-start justify-center p-4 sm:items-center sm:p-6">
      <div className="w-full max-w-2xl rounded-3xl bg-white p-4 shadow-2xl sm:p-8 md:p-10">
        <LogoMarque className="mb-8 h-9 w-auto" />

        {isLoading && <p className="text-sm text-codialis-gray">Chargement du questionnaire…</p>}

        {error && (
          <div>
            <h1 className="font-display text-2xl font-bold text-codialis-navy">Lien indisponible</h1>
            <p className="mt-2 text-sm text-codialis-gray">
              {error instanceof ErreurApi ? error.message : 'Le questionnaire n’a pas pu être chargé.'}
            </p>
          </div>
        )}

        {data && (
          <div className="space-y-5">
            <div>
              <h1 className="font-display text-2xl font-bold text-codialis-navy">{data.titre}</h1>
              <p className="mt-1 text-sm text-codialis-gray">Bonjour {data.prenom}, merci de prendre ce temps.</p>
            </div>
            {data.repondLe || repondre.isSuccess ? (
              <p className="rounded-xl bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
                Merci ! Vos réponses ont bien été enregistrées.
              </p>
            ) : (
              <FormulaireQuestionnaire
                questionnaire={data}
                enCours={repondre.isPending}
                erreur={repondre.error instanceof ErreurApi ? repondre.error.message : null}
                onEnvoyer={(reponses) => repondre.mutate(reponses)}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
